/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_Invite_FromInputs */

const en_scene_frontrow_invite_from = /** @type {(inputs: Scene_Frontrow_Invite_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From Tomorrow, via Guestlist`)
};

/**
* | output |
* | --- |
* | "From Tomorrow, via Guestlist" |
*
* @param {Scene_Frontrow_Invite_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_invite_from = /** @type {((inputs?: Scene_Frontrow_Invite_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_Invite_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_invite_from(inputs)
});